import React from 'react'
import { Box } from '@maui/elements'

export function LayoutWrapper(props) {
  return (
    <Box
      display='flex'
      flexDirection='row'
      flexWrap='wrap'
      gap='spaceGapXLarge'
      alignItems='flex-start'
      {...props}
    >
      {props.children}
    </Box>
  )
}

export function LayoutColumn(props) {
  return (
    <Box
      display='flex'
      flexDirection='column'
      gap='spaceGapXLarge'
      {...props}
    >
      {props.children}
    </Box>
  )
}
